<div
  *ngIf="isLoading"
  class="position-absolute top-50 start-50 translate-middle bg-opacity-75 rounded-3 p-4 d-flex flex-column align-items-center"
  style="z-index: 1000"
>
  <div class="spinner-border text-primary mb-2" role="status"></div>
  <span class="fw-semibold text-muted">{{ message }}</span>
</div>
